import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import React, { ChangeEventHandler, useRef } from 'react'
import Button from 'app/modules/shared/components/button'

export const FileInputButton = ({
  handleFile,
  buttonId,
}: {
  handleFile: (args: FileList) => any
  buttonId: string
}) => {
  const hiddenFileInput = useRef<HTMLInputElement | null>(null)
  const { _t } = useTypedTranslation()

  const handleClick = () => {
    if (hiddenFileInput.current) {
      // Clears the file input's value so the input can pick up onchange event
      hiddenFileInput.current.value = ''
      hiddenFileInput.current.click()
    }
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const fileUploaded = (event.target as HTMLInputElement).files!
    handleFile(fileUploaded)
  }

  return (
    <>
      <Button id={buttonId} variant="primary" className="button-upload" onClick={handleClick}>
        {_t('upload-file')}
      </Button>
      <input type="file" onChange={handleChange} hidden readOnly id="file-upload-input" ref={hiddenFileInput} />
    </>
  )
}
